function displayFolio(guide) {
	if (!guide) return '';
	return String(guide.folio ?? guide.guide_number ?? '').trim();
}

/**
 * Agrupa líneas seleccionadas del picker por residue_id.
 */
export function aggregateGuideLinesByResidue(lines) {
	if (!Array.isArray(lines) || lines.length === 0) {
		return [];
	}
	const map = new Map();
	for (const line of lines) {
		const residueId = String(
			line.residue_id || line.residue?._id || 'unknown',
		);
		const kg = Number(line.kilograms_to_send);
		const folio = displayFolio(line.guide);
		const bucket = map.get(residueId) || {
			residue_id: residueId,
			residue: line.residue,
			guide_details: [],
			kilograms_total: 0,
			source_guide_folios: [],
			guide_detail_ids: [],
			original_guide_ids: [],
			individual_kilograms: [],
		};
		bucket.guide_details.push(line);
		bucket.kilograms_total += Number.isFinite(kg) ? kg : 0;
		bucket.guide_detail_ids.push(String(line._id));
		bucket.original_guide_ids.push(
			String(line.guide_id || line.guide?._id || ''),
		);
		bucket.individual_kilograms.push(Number.isFinite(kg) ? kg : 0);
		if (folio && !bucket.source_guide_folios.includes(folio)) {
			bucket.source_guide_folios.push(folio);
		}
		map.set(residueId, bucket);
	}
	return [...map.values()];
}

/**
 * Un ítem DTE por grupo de residuo (D-028).
 */
export function transformGuideDetailsToItemsByResidue(group, lineIndex) {
	const foliosText = (group.source_guide_folios || []).join(',');
	const residueName = group.residue?.name || 'Residuo';
	const description = foliosText
		? `DE GUIA ${foliosText}`.trim()
		: 'DE GUIA';

	return {
		NroLinDet: lineIndex,
		NmbItem: residueName,
		DscItem: description,
		QtyItem: Number(group.kilograms_total || 0),
		UnmdItem: 'KG',
		PrcItem: 0,
		MontoItem: 0,
		VlrCodigo: group.residue?.code || '',
		TpoCodigo: '',
		_module_vars: {
			_is_warehouse_guide_lines_send: true,
			residue_id: group.residue_id,
			residue: group.residue,
			guide_detail_ids: [...group.guide_detail_ids],
			original_guide_ids: [...group.original_guide_ids],
			individual_kilograms: [...group.individual_kilograms],
			source_guide_folios: [...group.source_guide_folios],
			kilograms_total: Number(group.kilograms_total || 0),
		},
	};
}
